import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { ReviewComponent } from '../review-management/review.component';

@Component({
  selector: 'app-related-product-pagination',
  templateUrl: './related-product-pagination.component.html',
  styleUrls: ['./related-product-pagination.component.css']
})
export class RelatedProductPaginationComponent implements OnInit {

  @Output() loadPage = new EventEmitter();
  @Input('totalPages') totalPages: number;
  @Input('pageNumber') pageNumber: number;
  @Input('pageSize') pageSize: number;
  isNextPageAvailable: boolean;
  isPrevPageAvailable: boolean;

  ngOnChanges(changes: any) {
    for (let propName in changes) {
      if (propName == 'totalPages') {
        if (this.totalPages == undefined || this.totalPages <= 0) {
          this.totalPages = 1;
        }
        this.pageButtonSettings();
        break;
      }
    }
  }

  constructor() {
    this.pageNumber = 1;
    this.pageSize = 4;
    this.isNextPageAvailable = true;
    this.isPrevPageAvailable = false;
    this.pageButtonSettings();
  }

  ngOnInit() {
  }

  nextPage() {
    this.pageNumber++;
    this.pageButtonSettings();
    this.pageLoad();
  }

  prevPage() {
    this.pageNumber--;
    this.pageButtonSettings();
    this.pageLoad();
  }

  pageChangeEvent() {
    this.pageButtonSettings();
    this.pageLoad();

  }

  pageLoad() {
    var pagingModel = new PagingModel;
    pagingModel.pageSize = this.pageSize;
    pagingModel.pageNumber = this.pageNumber;
    this.loadPage.emit(pagingModel);
  }

  pageButtonSettings() {
    if (this.totalPages <= 1) {
      this.isNextPageAvailable = false;
    }
    if (this.pageNumber <= 1) {
      this.isPrevPageAvailable = false;
    }
    if (this.pageNumber > 1) {
      this.isPrevPageAvailable = true;
    }
    if (this.pageNumber == this.totalPages) {
      this.isNextPageAvailable = false;
    }
    else {
      this.isNextPageAvailable = true;
    }
    if (this.pageNumber <= 1 && this.pageNumber < this.totalPages) {
      this.isNextPageAvailable = true;
      this.isPrevPageAvailable = false;
    }
  }
}
